const CONFIG_PATH = "meta/game_map_res.json"

let loaded = false;
let MapResConfig = {}
MapResConfig.load = function () {
    if (!loaded) {
        let config =  ResManager.get(CONFIG_PATH);
        this.DependingAssetsTypeNameMap = format(config.DependingAssetsTypeNameMap);
        this.OrderTargetResMap = format(config.OrderTargetResMap);
        this.PetResMap = format(config.PetResMap);
        loaded = true;
    }
}

function format(map) {
    let result = {}
    for (let key in map) {
        result[key] = $tableToArray(map[key]);
    }
    return result;
}

MapResConfig.ConfigPath= CONFIG_PATH
module.exports = MapResConfig